import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ExaminationSessionDetailedDto,
  ExaminationSessionDto,
} from './examination-session.model';

export const ExaminationSessionActions = createActionGroup({
  source: 'ExaminationSession API',
  events: {
    'Load Examination Sessions': emptyProps(),
    'Load Examination Sessions Success': props<{
      questionnaireIds: string[];
      examinationSessions: ExaminationSessionDto[];
    }>(),
    'Load Examination Sessions Failure': props<{ error: Error }>(),
    'Get Examination Session Detailed Success': props<{
      examinationSession: ExaminationSessionDetailedDto;
    }>(),
    'Get Examination Session Detailed Failure': props<{ error: Error }>(),
  },
});

export const ExaminationSessionAnswersModalActions = createActionGroup({
  source: 'Examination Session Answers Modal',
  events: {
    'Modal Closed': emptyProps(),
  },
});
